import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { saasApi } from '../../lib/api';

function Stat({ label, value, suffix }) {
  return (
    <div className="bg-surface rounded-2xl shadow-sm p-5">
      <p className="font-label-sm text-label-sm text-on-surface-variant">{label}</p>
      <p className="mt-1 font-h3 text-h3 text-on-surface">
        {value}
        {suffix && <span className="text-[11px] text-on-surface-variant ml-1">{suffix}</span>}
      </p>
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    saasApi.stats().then(setStats).catch((e) => setError(e.message));
  }, []);

  if (error) return <p className="text-[11px] text-error">{error}</p>;
  if (!stats) return <p className="text-[11px] text-on-surface-variant">Carregando…</p>;

  return (
    <div className="flex flex-col gap-base">
      <div>
        <h1 className="studio-uniform-title font-h2 text-h2 text-on-surface">Dashboard SaaS</h1>
        <p className="font-body-md text-body-md text-on-surface-variant mt-2">
          Visío geral da plataforma EtiquetandoApp Studio.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <Stat label="Tenants" value={stats.tenants.total} />
        <Stat label="Usuários" value={stats.users} />
        <Stat label="Templates" value={stats.templates} />
        <Stat label="Pagamento pendente" value={stats.invoices.pending} />
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        <div className="bg-surface rounded-2xl shadow-sm p-6">
          <h3 className="studio-uniform-title font-h3 text-h3 text-on-surface">Tenants por plano</h3>
          {Object.entries(stats.tenants.byPlan).length === 0 ? (
            <p className="mt-3 text-[11px] text-on-surface-variant">Nenhum tenant ainda.</p>
          ) : (
            <ul className="mt-3 space-y-1 font-body-md text-body-md">
              {Object.entries(stats.tenants.byPlan).map(([plan, count]) => (
                <li key={plan} className="flex justify-between border-b border-surface-container-highest py-2">
                  <span className="capitalize text-on-surface-variant">{plan}</span>
                  <span className="font-medium text-on-surface">{count}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="bg-surface rounded-2xl shadow-sm p-6">
          <h3 className="studio-uniform-title font-h3 text-h3 text-on-surface">Faturamento</h3>
          <ul className="mt-3 space-y-1 font-body-md text-body-md">
            <li className="flex justify-between border-b border-surface-container-highest py-2">
              <span className="text-on-surface-variant">Faturas totais</span>
              <span className="font-medium text-on-surface">{stats.invoices.total}</span>
            </li>
            <li className="flex justify-between border-b border-surface-container-highest py-2">
              <span className="text-on-surface-variant">Pagas</span>
              <span className="font-medium text-on-surface">{stats.invoices.paid}</span>
            </li>
            <li className="flex justify-between border-b border-surface-container-highest py-2">
              <span className="text-on-surface-variant">Pendentes</span>
              <span className="font-medium text-on-surface">{stats.invoices.pending}</span>
            </li>
          </ul>
        </div>
      </div>

      <Link to="/admin/tenants" className="text-primary font-medium text-[11px] hover:underline">
        Gerenciar tenants →
      </Link>
    </div>
  );
}


